module.exports = __webpack_public_path__ + "a38768ab8bbd106d484a35d2aa1cdbb8.svg";